import { Identified } from '../../../base/identified.type';

export class EmailLogPresenterModel implements Identified<string> {
  id: string;
  /**
   * The sender email address.
   */
  from: string;
  /**
   * The email addresses of the recipient.
   */
  to: string[];
  /**
   * The email addresses of CC recipient.
   */
  cc: string[];
  /**
   * The email addresses of BCC recipient.
   */
  bcc: string[];
  /**
   * The subject of the Email.
   */
  subject: string;
  /**
   * The body of the Email.
   */
  body: string;
  /**
   * The message id from the service bus.
   */
  messageId?: string;
  /**
   * The timestamp when the Email was generated by the system.
   */
  generatedAt: string;
  /**
   * The timestamp when the Email was sent.
   */
  timestamp: string;
  /**
   * Whether the Email was sent successfully or not.
   */
  status: string;
  /**
   * The error message generated in case an exception is thrown
   */
  errorMessage?: string;
  /**
   * The response returned frm the SMTP provider.
   */
  responseCode?: any;
  /**
   * The related trigger execution id if the Email was sent as a result of a trigger.
   */
  relatedTriggerExecutionId: string | null;
}
